import BlogEdit from "components/Cards/BlogEdit";
import React from "react";


export default function EditBlog() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <BlogEdit />
        </div>
      </div>
    </>
  );
}
